import React from 'react';
import { Box } from '@mui/material';
import { styles } from './assigneeChip.style';

const AssigneeChip = ({ assignee }) => {
  if (!assignee) return;
  return (
    <Box sx={styles.chip}>
      <Box sx={styles.text}>
        {assignee?.firstName
          ? `${assignee?.firstName?.[0] ? `${assignee.firstName[0]}.` : ''}${
              assignee?.lastName || ''
            }`
          : assignee?.email}
      </Box>
    </Box>
  );
};

export default AssigneeChip;
